import {i18n} from '@/plugins/i18n'

export const profitSettlementType = {
    NotSettled: 1,
    SettledBySystem: 2,
    PartiallySettledBySystem: 3,
    SettledByAdmin: 4,
    Unknown: 5,
}

export const profitSettlementTypeStr = {
    NotSettled: i18n.t('label.daily_profit.settled_type.not_settled'),
    SettledBySystem: i18n.t('label.daily_profit.settled_type.settled_by_system'),
    PartiallySettledBySystem: i18n.t('label.daily_profit.settled_type.partially_settled_by_system'),
    SettledByAdmin: i18n.t('label.daily_profit.settled_type.settled_by_admin'),
    Unknown: i18n.t('label.daily_profit.settled_type.unknown'),

    get(type) {
        let settlement_type_str = null;

        Object.keys(profitSettlementType).forEach(item => {
            if (profitSettlementType[item] === type) {
                settlement_type_str = profitSettlementTypeStr[item];
            }
        });

        return settlement_type_str;
    }
};

export const profitSettlementTypeVariant = (variant) => {
    switch (variant) {
        case profitSettlementType.NotSettled:
        case profitSettlementType.Unknown:
            return 'danger';
        case profitSettlementType.SettledBySystem:
            return 'success';
        case profitSettlementType.PartiallySettledBySystem:
            return 'primary';
        case profitSettlementType.SettledByAdmin:
            return 'dark';

    }

    return 'warning';
};
